<div class="grid grid-cols-12 gap-5 py-4">
  @for (button of buttons; track $index) {
    <!-- *render="button.isForRoot !== undefined ? button.isForRoot : true" -->
    <div
      class="lg:col-span-3 md:col-span-6 sm:col-span-12 col-span-12 relative group m-0"
      [ngClass]="{ 'cursor-not-allowed': button.notAllowed }"
      pTooltip="No tiene permiso de acceso"
      [tooltipDisabled]="
        button?.notAllowed === false || button?.notAllowed === undefined
      "
    >
      <div
        class="flex justify-start items-center h-full rounded-md p-4 transition-all duration-200 relative"
        [routerLink]="button.link"
        [ngClass]="{
          'bg-gray-200/50 pointer-events-none cursor-not-allowed':
            button.notAllowed,
          'bg-white cursor-pointer shadow-md group-hover:shadow-lg group-hover:shadow-primary-900/10':
            !button.notAllowed,
        }"
        pTooltip="No tiene permisos de acceso"
        [tooltipDisabled]="!button.notAllowed"
        tooltipPosition="bottom"
      >
        <img
          src="svg/{{ button.svg }}.svg"
          alt="Icono"
          width="50"
          class="mr-2 transition-all duration-200"
          [ngClass]="{ 'group-hover:-translate-y-1': !button.notAllowed }"
        />
        <h3
          class="text-2xl transition-all duration-200"
          [ngClass]="{
            'group-hover:-translate-y-1': !button.notAllowed,
            'text-gray-500': button.notAllowed,
          }"
        >
          {{ button.titulo }}
        </h3>
        @if (button.notAllowed) {
          <i
            class="pi pi-lock font-bold text-gray-500 absolute bottom-2 right-2"
          ></i>
        }
      </div>
    </div>
  }
</div>
